var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2448 2.60597V14.0604H10.4252L11.6762 15.3331H0V1.33325H14.3152V8.33319H13.0704V2.60597H9.33598V5.78776H4.97919V2.60597H1.2448ZM8.09118 4.51504H6.22399V2.60597H8.09118V4.51504ZM2.48959 10.8786H7.46878V9.6059H2.48959V10.8786ZM6.22399 12.7877H2.48959V11.515H6.22399V12.7877ZM12.2656 9.15613L11.3855 10.0559L13.2527 11.965C13.3741 12.0891 13.5334 12.1515 13.6928 12.1515C13.8521 12.1515 14.0114 12.0891 14.1328 11.965L16 10.0559L15.1199 9.15613L13.6928 10.6153L12.2656 9.15613ZM12.2656 12.3379L13.6928 13.7971L15.1199 12.3379L16 13.2377L14.1328 15.1468C14.0114 15.2709 13.8521 15.3333 13.6928 15.3333C13.5334 15.3333 13.3741 15.2709 13.2527 15.1468L11.3855 13.2377L12.2656 12.3379Z",
    fill: "#4D4D54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeDrop);
export default __webpack_public_path__ + "static/media/safeDrop.00703d7800f25e5d9dfa5b00af81875f.svg";
export { ForwardRef as ReactComponent };